import React, {useEffect, useRef} from "react";
import { ThirdPartyDraggable } from "@fullcalendar/interaction";
import {useDrag} from "react-dnd";
import {useRawTranslation} from "../../../effects/use_translation";
import {useSelector} from "react-redux";

const DragAndDropTypes = {
  EVENT: "event",
};

const AvailableBooking = ({ name, type, backgroundColor, color }) => {
  const [, drag] = useDrag({
    item: { type: DragAndDropTypes.EVENT }
  });

  return (
    <div
      ref={drag}
      data-event-name={name}
      data-event-type={type}
      data-event-text-color={color}
      data-event-color={backgroundColor}
      className="fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event mr-2"
      style={{width: "175px", height: "50px", background: backgroundColor, color: color, borderColor: "color", cursor: "pointer"}}
    >
      <div className="fc-event-main px-2"
           style={{background: backgroundColor, borderColor: backgroundColor, color: color}}
      >
        {name}
      </div>
    </div>
  );
};

const AvailableBookings = () => {
  const ref = useRef();
  const rawTranslation = useRawTranslation()
  const accountOrganization = useSelector(state => state.accountOrganization)

  useEffect(() => {
    let draggable = null

    if (ref.current) {
      draggable = new ThirdPartyDraggable(ref.current, {
        eventData: function (eventEl) {
          return {
            title: eventEl.getAttribute("data-event-name"),
            eventTitle: eventEl.getAttribute("data-event-name"),
            eventType: eventEl.getAttribute("data-event-type"),
            textColor: eventEl.getAttribute("data-event-text-color"),
            color: eventEl.getAttribute("data-event-color"),
            requiresRefresh: true,
          };
        },
        itemSelector: ".fc-event"
      });
    }

    return () => {
      draggable && draggable.destroy();
    };
  }, [ref]);

  return (
    <div id="external-events" className={"py-4"} style={{width: "175px", height: "100px", marginLeft: "1rem", marginBottom: "1rem", display: "flex"}} ref={ref}>
      <AvailableBooking name={rawTranslation("booking_manager.booking", "Buchung")} backgroundColor={accountOrganization?.brand_color_1 || "#0ECC46"} color={accountOrganization?.brand_color_2 || "#FFFFFF"} type={"buchung"} />
    </div>
  );
};

export default AvailableBookings;
